export const transition = { ease: [0.87, 0, 0.13, 1], duration: 0.6 };
